// extracted by mini-css-extract-plugin
export default {"loader":"Loader_loader__+lRPl","rotation":"Loader_rotation__7eXxl"};